// extracted by mini-css-extract-plugin
export var option = "_40-1";
export var optionActive = "_40-2";
export var pill = "_40-0";